import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/skaiciuokles/atlyginimo-skaiciuokle/src/App.tsx");
